import React, { useState } from "react";
import { Form } from "react-bootstrap";

/**
 * Quick period presets (Day / Week / Month) for the finance reports.
 * Returns a { from, to } date-range so the page can drive its existing
 * from_date / to_date filters.
 */

// Local YYYY-MM-DD (avoids the UTC shift toISOString() would introduce).
const iso = (d) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
    d.getDate()
  ).padStart(2, "0")}`;

export function periodRange(period) {
  const now = new Date();
  if (period === "day") {
    return { from: iso(now), to: iso(now) };
  }
  if (period === "week") {
    // Monday -> Sunday of the current week.
    const day = now.getDay(); // 0 = Sunday
    const monday = new Date(now);
    monday.setDate(now.getDate() - (day === 0 ? 6 : day - 1));
    const sunday = new Date(monday);
    sunday.setDate(monday.getDate() + 6);
    return { from: iso(monday), to: iso(sunday) };
  }
  if (period === "month") {
    const first = new Date(now.getFullYear(), now.getMonth(), 1);
    const last = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    return { from: iso(first), to: iso(last) };
  }
  return null;
}

/**
 * <PeriodFilter onChange={({ from, to }) => { setFromDate(from); setToDate(to); }} />
 * Picking a preset fills the date range; "Custom range" leaves the pickers alone.
 */
export default function PeriodFilter({ onChange }) {
  const [period, setPeriod] = useState("");

  const handle = (e) => {
    const p = e.target.value;
    setPeriod(p);
    const range = periodRange(p);
    if (range) onChange(range);
  };

  return (
    <Form.Select value={period} onChange={handle} title="Quick period">
      <option value="">Custom range</option>
      <option value="day">Today</option>
      <option value="week">This Week</option>
      <option value="month">This Month</option>
    </Form.Select>
  );
}
